var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListGrid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H7.11111V8.88889H0V0Z",
    fill: "#999999"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.88889 0H32V8.88889H8.88889V0Z",
    fill: "#999999"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 11.5555H7.11111V20.4444H0V11.5555Z",
    fill: "#999999"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.88889 11.5555H32V20.4444H8.88889V11.5555Z",
    fill: "#999999"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 23.1111H7.11111V32H0V23.1111Z",
    fill: "#999999"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.88889 23.1111H32V32H8.88889V23.1111Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListGrid);
export default __webpack_public_path__ + "static/media/listGrid.46967e41ab0aaae60f1c2fc62d0416cf.svg";
export { ForwardRef as ReactComponent };